// src/pages/SellerSuccess/FeaturesList.jsx
import React from 'react';
import { sellerSuccessStyles } from './styles';
import { LAYOUT } from '../../constants';

// Modern SVG Icons
const DollarSignIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="1" x2="12" y2="23"></line>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
  </svg>
);

const TrendingUpIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="23,6 13.5,15.5 8.5,10.5 1,18"></polyline>
    <polyline points="17,6 23,6 23,12"></polyline>
  </svg>
);

const ShieldIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
  </svg>
);

const FeaturesList = () => {
  const features = [
    {
      icon: <DollarSignIcon />,
      title: 'Direct Payments',
      description: 'Get paid directly to your bank account with next-business-day transfers'
    },
    {
      icon: <TrendingUpIcon />,
      title: 'Sales Dashboard',
      description: 'Track your earnings, sales, and performance analytics in real-time'
    },
    {
      icon: <ShieldIcon />,
      title: 'Secure & Protected',
      description: 'Industry-leading security with buyer and seller protection included'
    }
  ];

  const sectionTitle = {
    fontSize: '1.8rem',
    fontWeight: '600',
    color: '#1f2937',
    textAlign: 'center',
    marginBottom: LAYOUT.spacing.xl,
  };

  return (
    <div style={sellerSuccessStyles.featuresSection}>
      <h2 style={sectionTitle}>What You Can Do Now</h2>
      <div style={sellerSuccessStyles.featuresGrid}>
        {features.map((feature, index) => (
          <div key={index} style={sellerSuccessStyles.featureCard}>
            <div style={sellerSuccessStyles.featureIcon}>
              {feature.icon}
            </div>
            <h3 style={sellerSuccessStyles.featureTitle}>{feature.title}</h3>
            <p style={sellerSuccessStyles.featureDescription}>{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturesList;